/**
 * Grid Search Handler
 *
 * Generic search handler for StandardDataGrid that works with any collection.
 * Maps collection names to their Redux actions and selectors.
 */

import { searchEmployees } from '../actions/employeeActions'
// Import other search actions as needed
// import { searchAllowances } from '../actions/allowanceActions'

/**
 * Map of collection names to their search actions
 */
const SEARCH_ACTIONS = {
  employees: searchEmployees,
  // allowances: searchAllowances,
  // Add other collections here
}

/**
 * Get search action for a collection
 */
export const getSearchAction = (collectionName) => {
  const action = SEARCH_ACTIONS[collectionName]
  if (!action) {
    throw new Error(`No search action found for collection: ${collectionName}`)
  }
  return action
}

/**
 * Build search parameters from grid state
 */
export const buildSearchParams = (gridState) => {
  const {
    filterQuery = [],
    sortField,
    sortDirection,
    pageSize = 25,
    page = 0,
    visibleColumns = [],
    populateFields = [],
    aggregate = true  // Default to true (only show approved versions)
  } = gridState

  return {
    query: filterQuery,
    sort: sortField,
    direction: sortDirection,  // Backend expects 'direction' not 'sortDirection'
    limit: pageSize,
    offset: page * pageSize,
    columns: visibleColumns.length > 0 ? visibleColumns : undefined,
    populate: populateFields.length > 0 ? populateFields : undefined,
    aggregate  // Enable/disable version aggregation based on toggle
  };
}

/**
 * Execute search for a collection
 */
export const executeSearch = (dispatch, collectionName, gridState) => {
  const searchAction = getSearchAction(collectionName)
  const searchParams = buildSearchParams(gridState)

  dispatch(searchAction(searchParams))
}
